import {
  CHAMPIONSHIP_FEES,
  CHICKEN_FIGHT_FEES,
  DEPOSIT_ACCOUNTS,
  DEPOSIT_NOTICE,
  ENTRY_FEES,
} from "@/domain/entry/model/EntryFee"

/**
 * 참가비 · 입금 계좌 본문.
 *
 * 안내 화면(`/fee`)과 신청 폼이 같은 내용을 보여주므로 조각으로 뺀다 —
 * 감싸는 면(카드 · 스크롤 박스)은 쓰는 화면이 정한다.
 */
export default function EntryFeeNotice() {
  return (
    <div className="flex flex-col gap-6">
      <section>
        <h3 className="app-txt-h3">참가비</h3>
        <dl className="app-grid-hairline mt-3 sm:grid-cols-2">
          {ENTRY_FEES.map((fee) => (
            <div key={fee.target}>
              <dt className="app-txt-caption text-app-text-200">
                {fee.target}
              </dt>
              <dd className="app-txt-h3 mt-1.5 text-app-primary-600">
                {fee.amountText}
              </dd>
            </div>
          ))}
        </dl>
      </section>

      <section>
        <h3 className="app-txt-h3">생활체육 챔피언전</h3>
        <dl className="app-grid-hairline mt-3 sm:grid-cols-2">
          {CHAMPIONSHIP_FEES.map((fee) => (
            <div key={fee.target}>
              <dt className="app-txt-caption text-app-text-200">
                {fee.target}
              </dt>
              <dd className="app-txt-h3 mt-1.5 text-app-primary-600">
                {fee.amountText}
              </dd>
              <dd className="app-txt-body2 mt-1 text-app-text-300">
                {fee.awardText}
              </dd>
            </div>
          ))}
        </dl>
      </section>

      <section>
        <h3 className="app-txt-h3">닭싸움</h3>
        <dl className="app-grid-hairline mt-3 sm:grid-cols-2">
          {CHICKEN_FIGHT_FEES.map((fee) => (
            <div key={fee.target}>
              <dt className="app-txt-caption text-app-text-200">
                {fee.target}
              </dt>
              <dd className="app-txt-h3 mt-1.5 text-app-primary-600">
                {fee.amountText}
              </dd>
            </div>
          ))}
        </dl>
      </section>

      <section>
        <h3 className="app-txt-h3">입금 계좌</h3>
        <ul className="app-grid-hairline mt-3 list-none">
          {DEPOSIT_ACCOUNTS.map((account) => (
            <li key={account.accountNo}>
              <p className="app-txt-caption text-app-text-200">
                {account.sportsText}
              </p>
              <p className="app-txt-h3 mt-1.5">
                {account.bankName} {account.accountNo}
              </p>
              <p className="app-txt-body2 mt-1 text-app-text-300">
                예금주: {account.holderName}
              </p>
            </li>
          ))}
        </ul>
      </section>

      <p className="app-alert app-alert-brand">※ {DEPOSIT_NOTICE}</p>
    </div>
  )
}
